module.exports = __webpack_public_path__ + "img/geofisica_9-16_360.fb0a3a84.webp";